import { Dialog } from "primereact/dialog";
import PropTypes from "prop-types";

const Index = ({
  isExibirPDF,
  position = "center",
  tituloTela,
  stringPDF,
  modal = true,
  tamanhoTela,
  alturaTela,
  onHide,
}) => {
  const dimensaoTela = () => {
    let tela = {};
    let tipo = stringPDF.split(";");
    if (tamanhoTela && tamanhoTela.indexOf(".") > 0) {
      let css = tamanhoTela.split(".");
      tela = { ...tela, width: `${css[0]}${css[1]}` };
    } else if (tamanhoTela) {
      tela = { ...tela, width: `${tamanhoTela}px` };
    }
    if (tipo[0] === "data:application/pdf" && alturaTela && alturaTela.indexOf(".") > 0) {
      let css = alturaTela.split(".");
      tela = { ...tela, height: `${css[0]}${css[1]}` };
    } else if (tipo[0] === "data:application/pdf" && alturaTela) {
      tela = { ...tela, height: `${alturaTela}px` };
    }
    return tela;
  };

  const isPDF = () => {
    let tipo = stringPDF.split(";");
    if (tipo.length > 0) {
      if (tipo[0] === "data:application/pdf") {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const handleOnHide = () => {
    if (onHide) {
      onHide();
    }
  };
  return (
    <Dialog
      onHide={handleOnHide}
      header={tituloTela}
      style={{ width: "50vw" }}
      maximizable
      visible={isExibirPDF}
      modal={modal}
      position={position}
      contentStyle={dimensaoTela()}
    >
      {isPDF() ? <iframe style={{ width: "100%", height: "99%" }} src={stringPDF} /> : <embed src={stringPDF} />}
    </Dialog>
  );
};

Index.propTypes = {
  isExibirPDF: PropTypes.bool,
  modal: PropTypes.bool,
  alturaTela: PropTypes.string,
  position: PropTypes.string,
  tituloTela: PropTypes.string,
  stringPDF: PropTypes.string.isRequired,
  tamanhoTela: PropTypes.string,
  onHide: PropTypes.func.isRequired,
};
export default Index;
